import { cx } from '@linaria/core';
import { useRef, useState, useEffect } from 'react';
import { emitDomMutation } from '@pm2/common-utils';
import { useLocation } from '@provider/navigation';
import { useIsPrintableContent } from '@provider/print';
import { resets } from '@ui/css';
import { isPlatformNodeJS, typesetKatex } from '@utils/common';
import { useChangeEffect } from '@utils/react';
import { listCls, itemCls, boundaryCls } from './accordion-component.style.js';
import { AccordionPanel } from './accordion-panel.js';
import { jsx } from 'react/jsx-runtime';

function AccordionComponent(props) {
  const isPrintContent = useIsPrintableContent();
  const location = useLocation();
  const ref = useRef(null);
  const [expanded, setExpanded] = useState(() => Object.fromEntries(props.panels.map((it, index) => [index, it.expandedInitially])));
  const handleToggle = (panelId, force) => {
    setExpanded(prevState => {
      if (prevState[panelId] && !force) {
        // if we're collapsing a panel, then override the state for that
        // specific panel
        return {
          ...prevState,
          [panelId]: false
        };
      }
      if (props.autoCollapse) {
        // if we're expanding a panel and autoCollapse has been enabled, then
        // expand only this specific panel
        return {
          [panelId]: true
        };
      }

      // ... otherwise expand the panel while leaving the rest of the state
      // "as is"
      return {
        ...prevState,
        [panelId]: true
      };
    });
  };

  // React to hash changes and expand the returned accordion if required.
  useEffect(() => {
    if (isPlatformNodeJS()) {
      return;
    }
    const shouldBeExpandedId = props.onHashChange?.();
    if (typeof shouldBeExpandedId !== "undefined") {
      handleToggle(shouldBeExpandedId, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.hash]);
  useChangeEffect(() => {
    typesetKatex(ref);
    emitDomMutation();
  }, [Object.entries(expanded).filter(([, expanded]) => expanded).map(([id]) => id).join("-")]);
  return /*#__PURE__*/jsx("section", {
    className: cx("gAccordion", resets.rootCls, boundaryCls),
    children: /*#__PURE__*/jsx("ul", {
      ref: ref,
      className: listCls,
      children: props.panels.map((it, index) => /*#__PURE__*/jsx("li", {
        className: itemCls,
        children: /*#__PURE__*/jsx(AccordionPanel, {
          ...it,
          collectionRef: ref,
          id: index,
          isLast: index === props.panels.length - 1,
          isExpanded: expanded[index] === true || isPrintContent,
          onToggle: handleToggle,
          canBeAutoCollapsed: props.autoCollapse
        })
      }, index))
    })
  });
}

export { AccordionComponent };
//# sourceMappingURL=accordion-component.js.map
